import logger from 'lib/logger'
import { Listing } from 'graphql/types'
import { TLocation } from './types'

export const cityDataCardButtonEvent = (url: string, label: string) =>
  logger.action('coverage-city-card-search-button', {
    url,
    label,
  })

export const neighborhoodDataCardButtonEvent = (url: string, label: string) =>
  logger.action('coverage-neighborhood-card-search-button', {
    url,
    label,
  })

export const moreListingsButtonEvent = (
  url: string,
  locationType: TLocation,
) => {
  const eventName =
    locationType === 'city'
      ? 'coverage-city-more-listings-button'
      : 'coverage-neighborhood-more-listings-button'

  return logger.action(eventName, { url })
}

export const featureListingEvent = ({
  url,
  listing,
  locationType,
}: {
  url: string
  listing: Listing
  locationType: TLocation
}) => {
  const eventName =
    locationType === 'city'
      ? 'coverage-city-feature-listing'
      : 'coverage-neighborhood-feature-listing'

  return logger.action(eventName, { url, listingId: listing?.id, ...listing })
}

export const collapseLocationsClickEvent = ({
  label,
  locationType,
}: {
  label: string
  locationType: TLocation
}) => {
  const eventName = {
    city: 'coverage-city-links-open',
    neighborhood: 'coverage-neighborhood-links-open',
    condominium: '',
  }[locationType]

  return logger.action(eventName, { label })
}

export const collapsePoisClickEvent = ({
  label,
  locationType,
}: {
  label: string
  locationType: TLocation
}) => {
  return logger.action(`coverage-${locationType}-pois-open`, { label })
}
export const collapseCondominiumsClickEvent = ({
  label,
}: {
  label: string
}) => {
  return logger.action('coverage-neighborhood-condominiums-open', { label })
}

export const locationItemClickEvent = ({
  url,
  label,
  locationType,
}: {
  url: string
  label: string
  locationType: TLocation
}) => {
  const eventName = {
    city: 'coverage-city-neighborhood-link',
    neighborhood: 'coverage-neighborhood-street-link',
    condominium: '',
  }[locationType]

  return logger.action(eventName, { label, url })
}

export const neighborhoodCondominiumItemClickEvent = ({
  url,
  label,
}: {
  url: string
  label: string
}) => {
  return logger.action('coverage-neighborhood-condominium-link', { label, url })
}

export const openRegionPageEvent = ({
  locationType,
  city,
  neighborhood,
}: {
  locationType: TLocation
  city?: string
  neighborhood?: string
  condominium?: string
}) => {
  const event = {
    city: {
      name: 'coverage-city-open',
      props: { city },
    },
    neighborhood: {
      name: 'coverage-neighborhood-open',
      props: { neighborhood },
    },
    condominium: {
      name: 'coverage-condominium-open',
      props: { neighborhood },
    },
  }[locationType]

  return logger.action(event.name, event.props)
}

export const heroCtaButtonClickEvent = (
  locationType: TLocation,
  url: string,
) => {
  const eventName = {
    city: 'coverage-city-search-button',
    neighborhood: 'coverage-neighborhood-search-button',
    condominium: 'coverage-condominium-search-button',
  }[locationType]

  return logger.action(eventName, { url })
}

export const breadcrumbEvent = (label: string, url: string) =>
  logger.action('covarage-area-breadcrumb', {
    label,
    url,
  })

export const headerContactButtonEvent = () =>
  logger.action('header-contact-button', {
    url: 'https://api.whatsapp.com/send?phone=551131976638&text=Quero%20falar%20com%20a%20EmCasa%20para%20tirar%20d%C3%BAvidas',
    label: 'Fale conosco',
  })

export const blogCardClickEvent = (label: string, url: string) =>
  logger.action('coverage-city-blog-link', {
    url,
    label,
  })

export const poiTabClickEvent = (locationType: TLocation, category: string) => {
  logger.action(`coverage-${locationType}-poi-tab`, {
    locationType,
    category,
  })
}

export const poiItemClickEvent = ({
  locationType,
  category,
  name,
}: {
  locationType: TLocation
  category: string
  name: string
}) =>
  logger.action(`coverage-${locationType}-poi-item`, {
    locationType,
    category,
    name,
  })
